import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './PSBarChart.scss';
import { currencyFormatter } from '../../Modules/JobRanges/Utils/Utils';

const propTypes = {
  label: PropTypes.string,
  height: PropTypes.number,
  maxHeight: PropTypes.number,
  roundTo: PropTypes.number,
  payType: PropTypes.string
};

export default class PSBarChart extends Component {
  static propTypes = propTypes;

  render() {
    const { height, roundTo: roundToNearest, payType, maxHeight, label } = this.props;

    const currHeight = (height / maxHeight) * 0.75 * 100 || 5;
    const barLabel = height && height > 0 ? height.toString() : 0;
    return (
      <div className={'column '} style={{ height: currHeight + '%' }}>
        <span className="label bar-label">
          {currencyFormatter(barLabel, {
            roundToNearest,
            payType
          })}
        </span>
        <span className="label x-axis-label">{label}</span>
      </div>
    );
  }
}
